import { render, staticRenderFns } from "./AssessmentCard.vue?vue&type=template&id=10a90e2e"
import script from "./AssessmentCard.vue?vue&type=script&lang=js"
export * from "./AssessmentCard.vue?vue&type=script&lang=js"
import style0 from "./AssessmentCard.vue?vue&type=style&index=0&id=10a90e2e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports